import { isSharedWorkerSupported } from ".";
import socketConfig from "../../frameworks/web/config/socketConfig";
import WebSocketSharedWorker from "@adapters/infrastructures/WebSocket.sharedworker";
import Stream from "@adapters/infrastructures/WebSocket";
export default (function () {
    return {
        stream: isSharedWorkerSupported
            ? new WebSocketSharedWorker()
            : new Stream(socketConfig.socketURL, socketConfig.port),
    };
});
